'use client';

import type { NextReminderCellProps } from './NextReminderCell.types';
import { FC, useContext } from 'react';
import { FirmSettingsContext } from '@/_contexts/FirmSettingsProvider';
import { Flex, Icon, Text, Timestamp } from '@/_components';
import { getNextReminderDateString } from './NextReminderCell.utils';

export const NextReminderCell: FC<NextReminderCellProps> = ({
  questionnaire,
}) => {
  const { firm } = useContext(FirmSettingsContext);

  const nextReminderDate: string | null = getNextReminderDateString(
    questionnaire,
    firm,
  );

  const isReminderDisabled: boolean = questionnaire.reminders_disabled;

  return (
    <Flex isYCentered={true} gap={2}>
      <Icon
        name={nextReminderDate ? 'bell' : 'prohibit'}
        size={12}
        color={!!nextReminderDate ? undefined : 'disabled'}
      />
      <Text color={!!nextReminderDate ? undefined : 'disabled'} type="tiny">
        {nextReminderDate ? (
          <Timestamp timestamp={nextReminderDate} hideTime={true} />
        ) : isReminderDisabled ? (
          'Disabled'
        ) : (
          'Not scheduled'
        )}
      </Text>
    </Flex>
  );
};
